import React from "react";

const NoRepayments = () => {
  return (
    <div className="jumbotron justify-content-center">
      <h3 className="h3 text-center text-primary"> No Repayments</h3>
    </div>
  );
};

export default NoRepayments;
